import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid) return;
    let cancelled = false;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch {}
      if (tries < 12) {
        setTimeout(() => setTries(t => t + 1), 2000);
      } else if (!cancelled) {
        setStatus("timeout");
      }
    };
    tick();
    return () => { cancelled = true; };
  }, [sid, tries]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--sand)" }}>
      <div className="card-warm p-10 text-center max-w-md w-full">
        {status === "paid" ? (
          <>
            <CheckCircle size={56} className="mx-auto text-[var(--forest)]" />
            <h1 className="font-serif-display text-3xl font-semibold mt-4" style={{ color: "var(--pine)" }}>Paiement confirmé</h1>
            <p className="mt-3 text-[var(--muted-text)]">Merci ! Retrouvez votre inscription ou votre carnet dans votre espace.</p>
            <Link to="/mon-espace" className="btn-primary mt-6 inline-flex" data-testid="payment-success-goto">Mon espace</Link>
          </>
        ) : status === "timeout" ? (
          <>
            <h1 className="font-serif-display text-3xl font-semibold" style={{ color: "var(--pine)" }}>En cours de traitement</h1>
            <p className="mt-3 text-[var(--muted-text)]">Le paiement met plus de temps que prévu. Consultez votre espace dans un instant.</p>
            <Link to="/mon-espace" className="btn-primary mt-6 inline-flex">Mon espace</Link>
          </>
        ) : (
          <>
            <Loader2 size={56} className="mx-auto animate-spin text-[var(--forest)]" />
            <h1 className="font-serif-display text-3xl font-semibold mt-4" style={{ color: "var(--pine)" }}>Confirmation en cours…</h1>
          </>
        )}
      </div>
    </div>
  );
}
